/**
 * Заворачивание абсолютного адреса в путь прокси.
 *
 * Адрес сервера вводит администратор, адреса нод аватаров приходят в
 * конфигурации — целей у прокси заранее нет. Поэтому клиент кладёт адрес в
 * сам путь: `https://lp.hron.uz/v1/x?a=1` → `/__proxy/https/lp.hron.uz/v1/x?a=1`.
 * Разворачивает его `devProxy.ts` в разработке и nginx/Caddy в проде.
 *
 * Сам формат пути живёт в `@/shared/proxyPath`: его же импортирует
 * dev-сервер, поэтому обе стороны не могут разойтись.
 *
 * Прокси отключается переменной `VITE_DIRECT_REQUESTS=true` — тогда запросы
 * уходят по абсолютному адресу, как во Flutter. Это имеет смысл только если
 * бекенд сам отдаёт CORS-заголовки.
 */

import { PROXY_PREFIX, decodeProxyPath, encodeProxyPath } from '@/shared/proxyPath';

export { PROXY_PREFIX, decodeProxyPath };

const DIRECT = import.meta.env.VITE_DIRECT_REQUESTS === 'true';

/** Включено ли проксирование. */
export function isProxyEnabled(): boolean {
  return !DIRECT;
}

/** Приводит адрес к тому виду, в котором его надо запрашивать из браузера. */
export function toRequestUrl(absoluteUrl: string): string {
  return isProxyEnabled() ? encodeProxyPath(absoluteUrl) : absoluteUrl;
}

/** Обратное преобразование — для журнала и сообщений об ошибках. */
export function fromRequestUrl(requestUrl: string): string {
  return decodeProxyPath(requestUrl) ?? requestUrl;
}
